import React from 'react';

function OAuthCallback() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="text-center p-8">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
          Redirecting to Effem...
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          If you're not redirected automatically, open the Effem app on your device.
        </p>
      </div>
    </div>
  );
}

export default OAuthCallback;
